import { Grid, Paper, Box, Tabs, Tab } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import Battery from '../SLD/Battery'
import SimulatorApi from "app/views/simulation/SimulatorApi";
import { useLocation, useNavigate } from "react-router-dom";
import ChargerTree, { MeterDetailDialog } from "app/views/setdepot/shared/ChargerTree";
import Link from './linknode/Link'
import Sld from '../SLD/Sld.js'
// import { DirectionsBusIcon } from "@mui/icons-material/DirectionBus";
import { useThemeContext } from 'app/ThemeProvider';
import Analytics from "./depot/Analytics";
import Dashboard from "./microgridSystem/Dashboard";
import MeterApi from "./meter-detail/MeterApi";
import Loading from "app/components/MatxLoading";
import Imagee from "app/views/test/App";


// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;
const ChargingBay = () => {


	const navigate = useNavigate();



	useEffect(() => {

		const permissions = JSON.parse(localStorage.getItem("permission"))
			.filter(obj => obj.type === 'navigation')
			.map(obj => obj.name) ?? [];



		if (!permissions.includes("Infra"))
			navigate('/setdepot/default');

	}, []);




	const [APIData, setAPIData] = useState([]);
	const api = new SimulatorApi();
	const meterApi = new MeterApi();

	const search = useLocation().search;

	const sim_type = new URLSearchParams(search).get("sim_type");
	const sel_vehicle = new URLSearchParams(search).get("vehicle");
	const [animateBorder, setAnimateBorder] = useState(false);
	const { darkTheme } = useThemeContext();
	const [meterDataList, setMeterDataList] = useState([]);

	const [loading, setLoading] = useState(false);

	const selectedDepot = localStorage.getItem('selected_depot');

	const handleAnimationStart = () => {
		setAnimateBorder(true);
	};

	const handleAnimationEnd = () => {
		setAnimateBorder(false);
	};

	useEffect(() => {

		setLoading(true)
		if (sim_type === "single_v") {
			showSingleChargerGraph(sel_vehicle);
		} else {
			showChargerStatusGraph();
		}
		const interval = setInterval(() => {
			if (sim_type === "single_v") {
				showSingleChargerGraph(sel_vehicle);
			} else {
				showChargerStatusGraph();
			}
		}, 10000);
		return () => clearInterval(interval);
	}, []);

	const showSingleChargerGraph = (vehicleId) => {
		api
			.showSingleChargerStatusGraph(null, vehicleId)
			.then((response) => {
				setAPIData(response.data);
			})
			.catch((e) => {
				// console.log("Cannot load event data", e);
			});
	};

	const showChargerStatusGraph = () => {
		
		api
			.showChargerStatusGraph()
			.then((response) => {
				setAPIData(response.data);
				setLoading(false)
			})
			.catch((e) => {
				// console.log("Cannot load event data", e);
			});
	};


	const showMeterByDepotId = (id) => {
		
		meterApi
			.getEnergyMeterByDepotId(id)
			.then((response) => {
				setMeterDataList(response.data);
				console.log(response)
			})
			.catch((e) => {
				console.log("Cannot load event data", e);
			});
	};

	console.log(meterDataList);

	const [borderColor, setBorderColor] = useState("transparent");
	const currentDepotId = localStorage.getItem("selected_depot");

	useEffect(() => {
		showMeterByDepotId(currentDepotId);
		setBorderColor((prevColor) =>
			prevColor === "transparent" ? "green" : "transparent"
		);
		const intervalId = setInterval(() => {
			setBorderColor((prevColor) =>
				prevColor === "transparent" ? "green" : "transparent"
			);
		}, 10000);
		return () => clearInterval(intervalId);
	}, []);

	// dynamic tabs based on depot
	const getTabsForDepot = (depotId) => {
	const baseTabs = [{ label: "HLD" }];

	if (depotId == 226 || depotId == 200)
		baseTabs.push({ label: "Microgrid" });

	if (depotId == 92) {
		baseTabs.push({ label: "Network Layout" });
		baseTabs.push({ label: "Depot" });
		baseTabs.push({ label: "SLD" });
	}

	return baseTabs;
	};

	const tabs = getTabsForDepot(selectedDepot);
	const [selectedTab, setSelectedTab] = useState(0);

	const handleChange = (event, newValue) => {
	setSelectedTab(newValue);
	};

	const paperStyle = {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignItems: "center",
		width: "100%",
		height: "174px",
		background: "#e7e7e7",
		padding: "4px 2px",
		borderRadius: "10px",
		border: `5px solid ${borderColor}`, // Border color changes based on the state
		transition: "border-color 0.5s ease", // CSS transition for the border color change
	};

	const backgroundColorSelected = darkTheme ? '#F2E34C' : 'black'; // Background color of selected tab
	const backgroundColorUnselected = darkTheme ? '#334155' : '#d9d9d9';
	const textColorSelected = darkTheme ? 'black' : 'white'; // Text color of selected tab
	const textColorUnselected = darkTheme ? 'white' : 'black';

	return (
		<Paper width={"100%"} sx={{ backgroundColor: darkTheme ? '#333333' : 'white' }}
		// style={{ padding: "10px", margin: "0", overflowX: "auto" }}
		// elevation={3} alignItems={"center"} justifyContent={"center"}
		>
			<Grid container direction={'row'} style={{ backgroundColor: darkTheme ? '#333333' : '#f9f9f9' }}>

				{/* <Grid item md={2} container>

				</Grid> */}


				<Grid item md={8} paddingLeft={"5px"}>
					<Grid container padding={"2px"} spacing={2}  >

						{
							selectedTab === 0 ? meterDataList.map(meter => {
								return <Grid item md={1.5}>
									{/* <Paper style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} elevation={3}> */}
									<MeterDetailDialog element={{ meter_id: meter.meterId, meter_pk: meter.id }} />
									<Grid container alignItems="center" justifyContent="center" style={{ width: "100%", padding: 0 }}>
										<b>{meter.deviceId}</b>

									</Grid>
									{/* </Paper> */}
								</Grid>
							}) : ""
						}
						{/* <Grid item md={2}>
							<Paper style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} elevation={3}>
								<MeterDetailDialog />
							</Paper>
						</Grid>
						<Grid item md={2}>
							<Paper style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} elevation={3}>
								<MeterDetailDialog />
							</Paper>
						</Grid>
						<Grid item md={2}>
							<Paper style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} elevation={3}>
								<MeterDetailDialog />
							</Paper>
						</Grid>
						<Grid item md={2}>
							<Paper style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} elevation={3}>
								<MeterDetailDialog />
							</Paper>
						</Grid> */}
					</Grid>
				</Grid>


				<Grid item xs={4}>
					<Box 
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						width: "100%",
						marginRight: "10%",
						padding: 0,
						pr: { xs: 1, sm: 2, md: 3 }
					}}>
					<Tabs
						value={selectedTab}
						onChange={handleChange}
						sx={{
							backgroundColor: darkTheme ? backgroundColorSelected : backgroundColorUnselected, 
							borderRadius: "12px",
							minHeight: "40px",
							padding: "2px",
							"& .MuiTabs-indicator": {
							height: "3px",
							backgroundColor: darkTheme ? textColorSelected : textColorUnselected, 
							},
						}}
						>
						{tabs.map((tab, index) => (
							<Tab
							key={tab.label}
							label={tab.label}
							sx={{
								minWidth: "auto",
								px: 2,
								fontSize: { xs: "0.65rem", sm: "0.75rem", md: "0.8rem" },
								fontWeight: 600,
								borderRadius: "10px",
								backgroundColor:
								selectedTab === index
									? backgroundColorSelected
									: backgroundColorUnselected,
								color: selectedTab === index ? textColorSelected : textColorUnselected,
								"&.Mui-selected": {
								color: textColorSelected + " !important", 
								},
								"&:hover": { opacity: 0.9 },
							}}
							/>
						))}
						</Tabs>


					</Box>
				</Grid>
				<Grid
					item
					xs={12}
					sx={{
						padding: selectedTab === 1 ? "1px" : "10px",  
						backgroundColor: darkTheme ? '#333333' : '#f9f9f9',
					}}
					>

					{selectedTab === 4 ?
						<Grid item container spacing={1} sx={{ backgroundColor: darkTheme ? '#333333' : '#f9f9f9' }}>

							{
								APIData && APIData.map((bay, index) => {
									return bay.map((element, index) => {
										return <Grid item md={1.5}><Battery element={element} /></Grid>
									})
								})
							}

							{/* <div><Battery chargeBoxId='GEXHYDSCK00042' /></div>
							<div ><Battery chargeBoxId='GEXHYDSCK00043' /></div>
							<div><Battery chargeBoxId='GEXHYDSCK00044' /></div>
							<div><Battery chargeBoxId='GEXHYDSCK00045' /></div> */}
						</Grid> : null}
				</Grid>


			</Grid>

			{selectedTab === 0 ?
				loading ? <Paper sx={{
					width: '100%', overflow: 'hidden', height: '60vh'
					, backgroundColor: darkTheme ? '#333333' : '#f9f9f9'
				}} ><Loading /></Paper> :
					APIData.map((bay) => (
						<Grid
							container
							// spacing={2}
							width={"100%"}
							alignItems={"center"} justifyContent={"center"}
							sx={{ backgroundColor: darkTheme ? '#333333' : '#f9f9f9' }}
						// wrap="nowrap"
						>
							<ChargerTree bay={bay} />
						</Grid>
					)) : null}

					{selectedTab === 1 && (parseInt(currentDepotId) === 226 || parseInt(currentDepotId) === 200) ? (
						<Box
							sx={{
								width: '100%',
								height: '100%',
								display: 'block',
								p: 0,
								m: 0,
								overflow: 'auto',
								backgroundColor: darkTheme ? '#333333' : '#f9f9f9',
							}}
						>
							<Dashboard />
						</Box>
					) : null}


			{/* For depot 92 */}
			{parseInt(currentDepotId) === 92 && selectedTab === 1 ? <Imagee /> : null}
			{parseInt(currentDepotId) === 92 && selectedTab === 2 ? <Analytics /> : null}
			{parseInt(currentDepotId) === 92 && selectedTab === 3 ? <Sld /> : null}

		</Paper>
	);
};

export default ChargingBay;